export default {
  setBoardList(state, { resBoardList }) {
    state.boardList = [...state.boardList, ...resBoardList];
  },

  setAlarmList(state, { resAlarmList }) {
    state.alarmList = [...state.alarmList, ...resAlarmList];
  },

  setFaqList(state, { resFaqList }) {
    state.faqList = [...state.faqList, ...resFaqList];
  },

  setBoardInfo(state, entity) {
    state.boardInfo = entity;
  },

  setAlarmInfo(state, entity) {
    state.alarmInfo = entity;
  },

  setPageInfo(state, pageInfo) {
    state.pageInfo = pageInfo;
  },

  setPage(state, page) {
    state.reqPageInfo.page = page;
  },

  resetPage(state) {
    state.reqPageInfo.page = 1;
  },
  resetList(state) {
    state.boardList = [];
  },
  resetFaqList(state) {
    state.faqList = [];
  },
  resetAlarmList(state) {
    state.alarmList = [];
  },
  resetPageInfo(state) {
    state.pageInfo = {
      page: 1,
      totalPage: 2
    };
  }
};
